import React from 'react';

import ItemSelected from '../ItemSelected';
import S from './styles';

function List({ data, itemSelected, renderItem }) {
  return (
    <>
      <ItemSelected item={itemSelected} />

      <S.ListSelect itemLayout="horizontal" dataSource={data} renderItem={renderItem} />
    </>
  );
}

export default List;
